import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Divider, Grid } from "@mui/material";
import {
  Btn,
  IconBtnBase,
  ResourcesList,
  setProgress,
} from "Components";
import Yup from "Utils/Yup";
import { makeStyles } from "@mui/styles";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import InvestorWeekCardDetails from "./Components/InvestorWeekCardDetails";
import FileDetails from "./Components/FileDetails";
import RefreshIcon from '@mui/icons-material/Refresh';
import { HOMEDETAIL } from 'Constants/QueriesKeys';
import { useQuery } from "react-query";
import { http } from "Utils/Http/Http";
import { toast } from "react-toastify";
import HeroBox from "Components/HeroBox/HeroBox";


const UPDATE_HOME = "UPDATE_HOME";

const investorWeekCardDetailsSchema = Yup.object({
  // heading: Yup.string().required("required"),
  // description: Yup.string().required("required"),
});

const fileDetailsSchema = Yup.object({
  fileName: Yup.string().required("required"),
});

const schema = Yup.object({
  investorWeekCardDetails: Yup
    .array()
    .of(investorWeekCardDetailsSchema),
  fileDetails: Yup
    .array()
    .of(fileDetailsSchema)
});
const useStyles = makeStyles((theme) => ({
  h3Text: {
    textTransform: 'capitalize',
    fontSize: '24px',
    color: 'rgb(3, 166, 90)',
    fontWeight: '500',
  },
  h4Text: {
    textTransform: 'capitalize',
    fontSize: '18px',
    color: 'rgb(3, 166, 90)',
    fontWeight: '500',
  },
  btn_delete: {
    fontSize: "12px",
    textTransform: "capitalize",
    color: "rgba(255,0,0,0.5)",
    margin: "0 20px",
    '&:hover': {
      color: 'rgba(255,0,0,0.7)',
    }
  },
}))
const InvestorWeek = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [enabled, setEnabled] = useState(true)
  const [prevFileDetails, setPrevFileDetails] = useState()
  const [prevDetails, setPrevDetails] = useState()
  const homePageQuery = useQuery([HOMEDETAIL], () =>
    http.get(`/api/v1/pages`, {}).then(({ data }) => {
      setEnabled(false);
      return (
        data,
        setPrevFileDetails(data?.data?.gulfInvestorWeekPage?.fileDetails),
        setPrevDetails(data?.data?.gulfInvestorWeekPage),
        reset({
          investorWeekCardDetails: data?.data?.gulfInvestorWeekPage?.investorWeekCardDetails,
          fileDetails: data?.data?.gulfInvestorWeekPage?.fileDetails,
          headerDetails: data?.data?.gulfInvestorWeekPage?.headerDetails
        })
      )
    }),
    {
      enabled: enabled ? true : false,
    },
  );
  const form = useForm({
    resolver: yupResolver(schema)
  });
  const { control, handleSubmit, reset, errors } = form;

  const handleFormSubmit = async (data) => {
    try {
      await http.post(`/api/v1/pages`, data)
        .then(async (res) => {
          toast.success(t('toast.success.updatedSuccessfully'))
          homePageQuery.refetch()
        });
    } catch (res) {
      toast.error(res?.response?.data?.message)
    }
    setProgress(UPDATE_HOME, false);
  }

  const fileFormSubmission = async (data, values) => {
    var newImageIndex = []
    let fileFormData = new FormData();
    for (var i = 0; i < values?.fileDetails?.length; i++) {
      // if (values?.fileDetails[i]?.src?.length > 0) {
      if (typeof (values?.fileDetails[i]?.src) === "object" && values?.fileDetails[i]?.src?.length > 0) {
        fileFormData.append("src", values?.fileDetails[i]?.src[0]);
        data['gulfInvestorWeekPage'].fileDetails[i].src = "new"
        newImageIndex.push(i)
      } else {
        data['gulfInvestorWeekPage'].fileDetails[i].src = prevFileDetails[i]?.src
      }
    }
    const runFileUpload = data?.gulfInvestorWeekPage?.fileDetails.filter((item) => item.src === "new")
    if (runFileUpload.length > 0) {
      try {
        await http.post(`/api/v1/helpers/upload-file`, fileFormData)
          .then(async (res) => {
            for (var i = 0; i < newImageIndex?.length; i++) {
              data['gulfInvestorWeekPage'].fileDetails[newImageIndex[i]].src = res.data.data[i].src
            }
            handleFormSubmit(data)
          });
      } catch (res) {
        toast.error(res?.response?.data?.message)
        setProgress(UPDATE_HOME, false);
      }
    } else {
      handleFormSubmit(data)
    }
  }

  const headerDataAdd = async (values) => {
    setProgress(UPDATE_HOME, true);

    let headerFormData = new FormData();

    var data = {
      gulfInvestorWeekPage: values
    }
    if (typeof (values?.headerDetails?.backgroundImage) === "object" && values?.headerDetails?.backgroundImage?.length > 0) {
      headerFormData.append("src", values?.headerDetails?.backgroundImage[0]);
      try {
        await http.post(`/api/v1/helpers/upload-file`, headerFormData)
          .then(async (res) => {
            data['gulfInvestorWeekPage'].headerDetails.backgroundImage = res.data.data[0].src
            fileFormSubmission(data, values)
          });
      } catch (res) {
        toast.error(res?.response?.data?.message)
        setProgress(UPDATE_HOME, false);
      }
    } else {
      data['gulfInvestorWeekPage'].headerDetails.backgroundImage = prevDetails?.headerDetails?.backgroundImage
      fileFormSubmission(data, values)
    }
  };
  return (
    <ResourcesList
      headerProps={{
        title: t('admin.cms.investorWeek.khalijiInvestorWeek'),
        EndSide: (
          <div className='flex'>
            <IconBtnBase
              onClick={() => { homePageQuery.refetch() }}
              size="large">
              <RefreshIcon />
            </IconBtnBase>
          </div>
        ),
      }}
      Section={
        <div className="mt-8">
          <Grid container>
            <Grid item xs={12}>
              <form
                onSubmit={handleSubmit(headerDataAdd)}
                className="space-y-3 py-5"
              >
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <h3 className={classes.h4Text}>{t('admin.cms.investorWeek.heroBox')}</h3>
                  </AccordionSummary>
                  <Divider style={{ margin: '10px 0' }} />
                  <AccordionDetails>
                    <HeroBox
                      form={form}
                      control={control}
                      errors={errors}
                      prevHeaderDetails={prevDetails?.headerDetails}
                    />
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <h3 className={classes.h4Text}>{t('admin.cms.investorWeek.investorWeekCardDetails')}</h3>
                  </AccordionSummary>
                  <Divider style={{ margin: '10px 0' }} />
                  <AccordionDetails>
                    <InvestorWeekCardDetails
                      form={form}
                      control={control}
                      errors={errors}
                    />
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <h3 className={classes.h4Text}>{t('admin.cms.investorWeek.filesGulfInvestorWeek')}</h3>
                  </AccordionSummary>
                  <Divider style={{ margin: '10px 0' }} />
                  <AccordionDetails>
                    <FileDetails
                      form={form}
                      control={control}
                      errors={errors}
                      prevFileDetails={prevFileDetails}
                    />
                  </AccordionDetails>
                </Accordion>
                <div className="flex pt-3">
                  <Btn fullWidth={false} type="submit" name={UPDATE_HOME}>
                    {t("common.submit")}
                  </Btn>
                </div>
              </form>
            </Grid>
          </Grid>
        </div>
      }
    />
  )
}

export default InvestorWeek